/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    UserActive: false,
    error: '',
    vendorInfo: {},
    mobileNumber: '',
    restaurantId: ''
  },
  reducers: {
    checkCurrentUser: (state, action) => {
      state.UserActive = action.payload.UserActive
    },
    SetCurrentUser: (state, action) => {
      state.UserActive = action.payload.UserActive
      state.error = action.payload.error
    },
    SignInStart: (state, action) => {
      state.mobileNumber = action.payload.mobileNumber
    },
    SignInSuccess: (state, action) => {
      state.UserActive = action.payload.UserActive
      state.error = ''
      if (action.payload.mobileNumber) {
        state.mobileNumber = action.payload.mobileNumber
      }
      if (action.payload.restaurantId) {
        state.restaurantId = action.payload.restaurantId
      }
    },
    SignInFailure: (state, action) => {
      state.UserActive = false
      state.error = action.payload.error.message
    },
    LogoutUser: (state, action) => {
      state.UserActive = false
      state.error = ''
      state.vendorInfo = {}
      state.mobileNumber = ''
      state.restaurantId = ''
    },
    LogoutSuccess: (state, action) => {
      state.UserActive = action.payload.UserActive
      state.error = action.payload.error
      state.vendorInfo = action.payload.vendorInfo
      state.mobileNumber = action.payload.mobileNumber
    },

    SetVendorInfo: (state, action) => {
      state.vendorInfo = action.payload.vendorInfo
      state.restaurantId = action.payload.vendorInfo.restaurantId
    },

    UpdateVendorInfo: (state, action) => {},
    SubmitVendorInfo: (state, action) => {}
  }
})

// Action creators are generated for each case reducer function
export const {
  checkCurrentUser,
  SetCurrentUser,
  SignInStart,
  SignInSuccess,
  SignInFailure,
  LogoutUser,
  LogoutSuccess,
  SetVendorInfo,
  UpdateVendorInfo
} = userSlice.actions

export default userSlice.reducer
